/***
 * TELCEL Montos disponibles
 */
export const TELCEL_AMOUNTS = [
  10.00, 20.00, 30.00, 50.00, 100.00, 200.00, 300.00, 500.00
];

/***
 * AT&T Montos disponibles
 */
export const ATT_AMOUNTS = [
  10.00, 20.00, 30.00, 50.00, 100.00, 150.00, 200.00, 300.00, 500.00, 600.00, 800.00, 1000.00, 1200.00
];

/***
 * MOVISTAR Montos disponibles
 */
export const MOVISTAR_AMOUNTS = [
  10.00, 20.00, 30.00, 50.00, 60.00, 70.00, 100.00, 120.00, 150.00, 200.00, 250.00, 300.00, 400.00
];
